<template>
  <div class="regexp-entity">
    <p class="entity-type--helptext">
      {{ $t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.bestForRaw') }}
      <br />
      {{ $t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.appliedAfterSpellcheck') }}
    </p>
    <or-textbox
      v-model="localEntity.name"
      :label="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.name.label')"
      :placeholder="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.name.placeholder')"
      :readonly="$props.isLoading"
      :error="$props.errors.name"
      :invalid="!!$props.errors.name"
      :disabled="isLoading"
      enforceMaxlength
    />
    <or-textbox
      v-model="localEntity.regexPattern"
      :label="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.regularExpression.label')"
      :placeholder="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.regularExpression.placeholder')"
      enforceMaxlength
      :readonly="$props.isLoading"
      :maxlength="expressionMaxLength"
      :error="$props.errors.regexPattern"
      :invalid="!!$props.errors.regexPattern"
      :disabled="isLoading"
    />
    <or-chips
      :label="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.roles.label')"
      :helpText="$t('model.nlu-model.sidebar.entities.editors.regexp-entity.regexpentity.roles.helpText')"
      :simpleText="true"
      :error="$props.errors.roles"
      :invalid="!!$props.errors.roles"
      :value="localEntity.roles"
      @input="updateRoles"
    />
  </div>
</template>

<script>
import { entitiesLimits } from '@/modules/limits'
import { ENTITY_TYPE } from '../../entity-types'

export const getDefaultRegexpEntity = () => ({
  name: '',
  regexPattern: '',
  roles: [],
  type: ENTITY_TYPE.regexp
})

export default {
  props: {
    isLoading: Boolean,
    entity: Object,
    errors: Object
  },

  computed: {
    localEntity: {
      get () {
        return this.$props.entity
      },
      set (entity) {
        this.$emit('update:entity', entity)
      }
    },

    expressionMaxLength () {
      return entitiesLimits.regexp.exp.max
    }
  },

  methods: {
    updateRoles (roles) {
      this.localEntity.roles = roles.map(role => role.replace(/`/g, ''))
    }
  }
}
</script>

<style scoped>
</style>
